'use client';

import
  Link
from 'next/link';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS,
  PRIMARY_BUTTON_CLASSES
} from '@repo/brand';

export default function NotFound() {

  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 sm:px-8">
      <div className="max-w-4xl mx-auto text-center">

        <h1
          className="text-[120px] sm:text-[180px] font-bold leading-none select-none"
          style={{
            background: BRAND_GRADIENT,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          404
        </h1>

        <h2 className="text-2xl sm:text-3xl font-light text-[#111111] dark:text-white mt-4 mb-4">
          Page not found
        </h2>

        <p className="text-base text-gray-500 dark:text-gray-400 mb-10 max-w-md mx-auto leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            href="/"
            className={`inline-flex items-center gap-3 px-7 py-3.5 ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS }`}
            style={{
              background: BRAND_GRADIENT
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="w-4 h-4 fill-white">
              <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
            </svg>
            Back to Home
          </Link>

          <Link
            href="/our-services"
            className="inline-flex items-center gap-3 text-sm font-semibold px-7 py-3.5 rounded-full border-2 transition-all duration-200 text-[#111111] dark:text-white hover:text-white"
            style={{
              borderColor: 'rgba(1,158,250,0.6)'
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = BRAND_GRADIENT)}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            Our Services
          </Link>
        </div>

      </div>
    </section>
  );
}
